module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row x-table-wrapper"
  }, [(_vm.enableFilter == true) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 mid-spacing filter-list"
  }, [(_vm.enableFilter == true) ? _c('x-filter', {
    attrs: {
      "filterDefinitions": _vm.filterDefinitions,
      "defaultfilters": _vm.fetchParams.searchFilters,
      "disabled": _vm.loading
    },
    on: {
      "update": _vm.updateFilters,
      "saveSearch": _vm.saveSearch
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.totalCount !== false) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 mid-spacing"
  }, [_c('h4', [_vm._v(_vm._s(_vm.totalCount) + " " + _vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.enableSearch == true) ? _c('div', {
    staticClass: "col-md-4 mid-spacing"
  }, [_c('div', {
    staticClass: "row items-end gutter-sm search-wrapper"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('q-search', {
    staticClass: "search",
    attrs: {
      "placeholder": _vm.$t('ui.xtable.search_placeholder'),
      "autofocus": "",
      "clearable": "",
      "hide-underline": "",
      "color": "secondary",
      "debounce": 600,
      "disabled": _vm.loading
    },
    on: {
      "input": function($event) {
        return _vm.updateSearch()
      }
    },
    model: {
      value: (_vm.fetchParams.searchKeywords),
      callback: function($$v) {
        _vm.$set(_vm.fetchParams, "searchKeywords", $$v)
      },
      expression: "fetchParams.searchKeywords"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('q-btn', {
    staticClass: "x-button",
    attrs: {
      "disabled": _vm.loading,
      "icon": "arrow_forward",
      "no-ripple": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateSearch(null, true)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 self-end mid-spacing x-table-menus"
  }, [_c('div', {
    staticClass: "column-toggle-menu dropdown-select float-right"
  }, [_c('q-table-columns', {
    staticClass: "columns",
    attrs: {
      "label": _vm.$t('ui.xtable.toggle_columns'),
      "color": "secondary",
      "columns": _vm.allColumns,
      "disabled": _vm.loading
    },
    on: {
      "input": _vm.columnChange
    },
    model: {
      value: (_vm.visibleColumns),
      callback: function($$v) {
        _vm.visibleColumns = $$v
      },
      expression: "visibleColumns"
    }
  })], 1), _vm._v(" "), (_vm.actions.length > 0 && _vm.actionsLocation == 'menu') ? _c('div', {
    staticClass: "actions-menu dropdown-select float-right"
  }, [_c('q-btn-dropdown', {
    staticClass: "x-table-actions-menu-button",
    attrs: {
      "label": _vm.$t('ui.xtable.actions'),
      "no-ripple": "",
      "no-caps": "",
      "disabled": _vm.loading
    }
  }, [_c('q-list', {
    attrs: {
      "link": ""
    }
  }, _vm._l((_vm.actions), function(action) {
    return _c('q-item', {
      directives: [{
        name: "close-overlay",
        rawName: "v-close-overlay"
      }],
      key: action.name,
      class: action.class,
      attrs: {
        "separator": action.separator ? true : false,
        "disabled": action.selectedOnly && _vm.selectedItems.length == 0
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleAction(action)
        }
      }
    }, [_c('q-item-main', {
      attrs: {
        "label": action.name
      }
    }), _vm._v(" "), (action.icon) ? _c('q-item-side', {
      attrs: {
        "icon": action.icon,
        "right": ""
      }
    }) : _vm._e(), _vm._v(" "), (action.description) ? _c('q-tooltip', [_vm._v(_vm._s(action.description))]) : _vm._e()], 1)
  }), 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "x-table col-xs-12 col-sm-12 col-lg-12 col-xl-12"
  }, [_c('q-table', {
    key: _vm.key,
    class: _vm.tableClasses,
    attrs: {
      "grid": "",
      "title": _vm.title,
      "data": _vm.tableData,
      "showLoader": _vm.loading,
      "disabled": _vm.loading,
      "pagination": _vm.fetchParams.pagination,
      "binary-state-sort": "",
      "columns": _vm.allColumns,
      "visible-columns": _vm.visibleColumns,
      "selection": _vm.selectionType,
      "selected": _vm.selectedItems,
      "separator": _vm.separator,
      "row-key": _vm.rowKey,
      "rows-per-page-label": _vm.$t('ui.xtable.page_size_label'),
      "no-data-label": _vm.emptyStateLabel,
      "rows-per-page-options": _vm.rowsPerPage
    },
    on: {
      "request": _vm.updatePagination,
      "update:selected": function($event) {
        _vm.selectedItems = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(props) {
        return _c('q-tr', {
          attrs: {
            "props": props
          }
        }, [(_vm.selectionType != 'none') ? _c('q-th', {
          staticClass: "column-selection",
          attrs: {
            "auto-width": ""
          }
        }, [_c('q-checkbox', {
          attrs: {
            "color": "primary"
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1) : _vm._e(), _vm._v(" "), _vm._l((props.cols), function(col) {
          return _c('q-th', {
            key: col.name,
            class: col.classes,
            attrs: {
              "props": props
            }
          }, [_vm._v("\n          " + _vm._s(col.label) + "\n        ")])
        }), _vm._v(" "), (_vm.actions.length > 0 && _vm.actionsLocation == 'row') ? _c('q-th', {
          staticClass: "column-standard text-center",
          attrs: {
            "auto-width": ""
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$t("ui.xtable.actions")) + "\n        ")]) : _vm._e()], 2)
      }
    }, {
      key: "body",
      fn: function(props) {
        return _c('q-tr', {
          class: _vm.rowsAreClickable ? 'cursor-pointer' : '',
          attrs: {
            "props": props
          },
          nativeOn: {
            "click": function($event) {
              return _vm.clickRow(props.row[_vm.rowKey])
            }
          }
        }, [(_vm.selectionType != 'none') ? _c('q-td', {
          staticClass: "column-selection",
          attrs: {
            "auto-width": ""
          }
        }, [_c('q-checkbox', {
          attrs: {
            "color": "primary"
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1) : _vm._e(), _vm._v(" "), _vm._l((props.cols), function(col) {
          return _c('q-td', {
            key: col.name,
            class: col.classes,
            attrs: {
              "props": props
            },
            nativeOn: {
              "click": function($event) {
                return _vm.clickCell(props.row[_vm.rowKey], col.name)
              }
            }
          }, [(col.icon) ? _c('img', {
            staticClass: "cell-icon",
            attrs: {
              "src": col.icon
            }
          }) : _vm._e(), _vm._v(" "), (_vm.isEmpty(col.value)) ? _c('span', {
            staticClass: "cell-text cell-empty"
          }, [_vm._v(_vm._s(_vm.defaultValue(col)))]) : (col.isUrl) ? _c('span', {
            staticClass: "cell-text"
          }, [_c('a', {
            attrs: {
              "target": "_blank",
              "href": 'http://' + col.value
            }
          }, [_vm._v(_vm._s(col.value))])]) : _c('span', {
            staticClass: "cell-text"
          }, [_vm._v(_vm._s(col.value))])])
        }), _vm._v(" "), (_vm.actions.length > 0 && _vm.actionsLocation == 'row') ? _c('q-td', {
          staticClass: "actions-cell",
          attrs: {
            "auto-width": ""
          },
          model: {
            value: (props.actions),
            callback: function($$v) {
              _vm.$set(props, "actions", $$v)
            },
            expression: "props.actions"
          }
        }, _vm._l((_vm.actions), function(action) {
          return _c('span', {
            key: action.name || action.icon
          }, [(/^yule-/.test(action.icon)) ? _c('a', {
            staticClass: "x-table-yule-icon",
            class: action.class,
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.handleAction(action, [props.row[_vm.rowKey]])
              }
            }
          }, [_c('i', {
            staticClass: "icon",
            class: action.icon
          })]) : _c('q-btn', {
            class: action.class,
            attrs: {
              "icon": action.icon,
              "size": "md",
              "flat": "",
              "round": "",
              "no-ripple": ""
            },
            nativeOn: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.handleAction(action, [props.row[_vm.rowKey]])
              }
            }
          }), _vm._v(" "), (action.description || action.name) ? _c('q-tooltip', [_vm._v(_vm._s(action.description || action.name))]) : _vm._e()], 1)
        }), 0) : _vm._e()], 2)
      }
    }])
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "title": _vm.savedSearchParams.title,
      "open": _vm.savedSearchModalOpen
    },
    on: {
      "save": function($event) {
        return _vm.saveSearchCommit()
      },
      "cancel": function($event) {
        return _vm.closeSavedSearchModal()
      }
    }
  }, [_c('field', {
    attrs: {
      "label": _vm.savedSearchParams.label
    },
    model: {
      value: (_vm.savedSearchName),
      callback: function($$v) {
        _vm.savedSearchName = $$v
      },
      expression: "savedSearchName"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-351676ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/XTable.vue
// module id = 1866
// module chunks = 0